import { ApplicationRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DOCUMENT } from '@angular/common';
import { first, take, takeUntil } from 'rxjs/operators';

import { StorageMap } from '@ngx-pwa/local-storage';
import { LoginAuthWithLanguage } from '@sk/sk-interfaces';
import { concat, interval, Subject } from 'rxjs';

@Component({
  selector: 'sk-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  updateAvailableVar = 'Update Available';
  reloadVar = 'Reload';
  unsubscribe$ = new Subject();

  constructor(private swUpdate: SwUpdate,
              private storage: StorageMap,
              private appRef: ApplicationRef,
              @Inject(DOCUMENT) private document: Document,
              private snackbar: MatSnackBar) {
    this.checkForUpdateListener();
    this.updateListener();
    this.unrecoverableStateListener();
  }


  private checkForUpdateListener() {
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const everyFourHours$ = interval(4 * 60 * 60 * 1000);
    const everyFourHoursOnceAppIsStable$ = concat(appIsStable$, everyFourHours$);

    everyFourHoursOnceAppIsStable$
      .subscribe(async () => {
        try {
          await this.swUpdate.checkForUpdate();
          console.log('Update check completed');
        } catch (err) {
          console.error('Failed to check for updates:', err);
        }
      });
  }


  private updateListener() {
    this.swUpdate.available
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(event => {
        console.log(event.type);
        const snack = this.snackbar.open(this.updateAvailableVar, this.reloadVar, { duration: 2500 });
        snack
          .afterDismissed()
          .subscribe(async () => {
            try {
              await this.swUpdate.activateUpdate();
              document.location.reload();
            } catch (e) {
              console.error('Failed to activate update:', e);
            }
          });


        setTimeout(() => {
          this.swUpdate.activateUpdate().then(() => document.location.reload());
        }, 3500);
      });
  }


  private unrecoverableStateListener() {
    this.swUpdate.unrecoverable
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(event => {
        console.log(event.type);
        const snack = this.snackbar.open(this.updateAvailableVar, this.reloadVar, { duration: 2500 });
        snack
          .afterDismissed()
          .subscribe(() => {
            document.location.reload();
          });

        setTimeout(() => {
          document.location.reload();
        }, 2200);
      });


  }


  ngOnInit(): void {
    this.languageListener();
  }

  translate(updateAvailable: string, reload: string) {
    this.updateAvailableVar = updateAvailable;
    this.reloadVar = reload;
  }


  languageListener() {
    this.storage.get('auth')
      .pipe(
        take(1)
      )
      .subscribe((auth: LoginAuthWithLanguage) => {
        console.log('Hello from APP Language listener');
        // No user saved in indexDB
        if (!auth) {
          return;
        }
        // user saved in indexDB
        if (auth && auth.language) {
          const language = auth.language;
          const urlOrigin = this.document.location.origin;
          const url = this.document.location.href;
          if (url.includes('localhost')) {
            console.log('DEV');
            return;
          }
          switch (language) {
            case 'nl-NL':
              if (url.includes('/nl')) {
                return;
              }
              this.snackbar.open('Nederlands laden...', '');
              this.document.location.replace(`${urlOrigin}/nl/`);
              console.log('NL Scenario');
              break;
            case 'en-US':
              if (url.includes('/en')) {
                return;
              }
              this.snackbar.open('Loading English...', '');
              this.document.location.replace(`${urlOrigin}/en/`);
              console.log('EN Scenario');
              break;
            case 'es-US':
              if (url.includes('/es')) {
                return;
              }
              this.snackbar.open('Cargando idioma español...', '');
              this.document.location.replace(`${urlOrigin}/es/`);
              console.log('ES Scenario');
              break;
          }
        }
      });
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

